var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isfromCamp
        ? _c(
            "a-steps",
            { attrs: { current: _vm.current } },
            [
              _c("a-step", { attrs: { title: _vm.$t("Chooseplan") } }),
              _c("a-step", { attrs: { title: _vm.$t("invoiceInformation") } }),
              _c("a-step", { attrs: { title: _vm.$t("Payment") } }),
            ],
            1
          )
        : _vm._e(),
      _vm.isfromCamp
        ? _c(
            "a-steps",
            { attrs: { current: _vm.current } },
            [
              _c("a-step", { attrs: { title: _vm.$t("CreateCampaign") } }),
              _c("a-step", { attrs: { title: _vm.$t("Chooseplan") } }),
              _c("a-step", { attrs: { title: _vm.$t("invoiceInformation") } }),
              _c("a-step", { attrs: { title: _vm.$t("Payment") } }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }